import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import {environment} from "../../../../environments/environment";

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
    currentYear: number = new Date().getFullYear();
    visitorCount: string = '78218506';

    constructor(
        private router: Router,
        private activatedRoute: ActivatedRoute,
    ) {
    }

    ngOnInit(): void {
        this.randomizeVisitorCount();
    }

    goTo(url: any) {
        return this.router.navigateByUrl(url);
    }

    // Generate a slightly randomized visitor count for visual interest
    randomizeVisitorCount(): void {
        const baseCount = 78000000;
        const randomAddition = Math.floor(Math.random() * 300000);
        this.visitorCount = (baseCount + randomAddition).toString();
    }

    // Handle newsletter subscription
    subscribeNewsletter(email: string): void {
        // This would typically connect to a service to handle the subscription
        // console.log('Subscribing email:', email);
        // Add actual implementation later
    }

    goToUrl(url:any){
        window.open(url, '_blank');
    }

    protected readonly environment = environment;
}
